<template>
  <el-dialog
    title="Relatórios de Pretendentes"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    width="30%"
  >
    <el-form
      :model="relatorio"
      ref="form"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
      :rules="validacao"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Relatório">
            <el-select
              auto-complete="off"
              v-model="relatorio.nome"
              clearable
              placeholder
              style="width: 100%;"
            >
              <el-option
                v-for="item in tiposRelatorios"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <span v-if="exibirCampoPeriodo">Período</span>
      <el-row v-if="exibirCampoPeriodo" :gutter="24">
        <el-col :span="12">
          <el-form-item prop="dataInicial">
            <el-date-picker
              v-model="relatorio.dataInicial"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="dataFinal">
            <el-date-picker
              v-model="relatorio.dataFinal"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <el-row :gutter="24" v-if="exibirCampoCliente">
        <el-col :span="24">
          <el-form-item label="Pretendente" style="width: 100%">
            <el-select
              v-model="relatorio.pretendente"
              :remote-method="filtrarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder
              loading-text="Carregando clientes"
              no-data-text="Nenhum cliente encontrado"
              filterable
              clearable
              @clear="relatorio.pretendente = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in clientesDisponiveis"
                :key="item.id"
                :label="formatarSelectCliente(item)"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <p/>

      <el-row v-if="exibirCampoAtendente" :gutter="24">
        <el-col :span="24">
          <el-form-item label="Atendente">
            <el-select
              v-model="relatorio.usuario"
              :remote-method="filtrarUsuariosSelect"
              :loading="loadingUsuarios"
              @focus="filtrarUsuariosSelect"
              value-key="id"
              placeholder
              loading-text="Carregando usuários"
              no-data-text="Nenhum usuário encontrado"
              filterable
              clearable
              @clear="relatorio.usuario = undefined"
              remote
              reserve-keyword
              style="width: 100%"
            >
              <el-option
                v-for="item in usuariosDisponiveis"
                :key="item.id"
                :label="item.nome"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button type="primary" size="small" @click="gerar()" round class="btn-box-shadow">Gerar Relatório</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

import funcoes from "../../../util/funcoes.js";
import { TIPOS_IMOVEIS } from "../../../util/constantes.js";

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      tiposRelatorios: [
        {
          value: "PRETENDENTES_CADASTRADOS",
          label: "Pretendentes Cadastrados"
        },
        {
          value: "CONTATO_REALIZADO",
          label: "Contatos Realizados"
        }
      ],
      relatorio: {
        nome: "",
        usuario: {},
        pretendente: {
          operacao: "VENDA"
        },
        dataInicial: funcoes.primeiroDiaMes(),
        dataFinal: funcoes.ultimoDiaMes()
      },

      validacao: {
        dataInicial: [{ required: true }],
        dataFinal: [{ required: true }]
      },

      loadingUsuarios: false,
      loadingClientes: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      auxUsuario: {},
      usuariosSelecionados: [],
    };
  },
  computed: {
    ...mapState("vendasRelatoriosStore", {
      usuariosDisponiveis(state) {
        return state.usuariosDisponiveis;
      },
      clientesDisponiveis(state) {
        return state.clientesDisponiveis;
      }

    }),
    exibirCampoCliente() {
      return this.relatorio.nome == "CONTATO_REALIZADO";
    },
    exibirCampoAtendente() {
      return (
        this.relatorio.nome == "CONTATO_REALIZADO" || this.relatorio.nome == "PRETENDENTES_CADASTRADOS"
      );
    },
    exibirCampoPeriodo() {
      return this.relatorio.nome;
    },
    tiposImoveis() {
      return TIPOS_IMOVEIS;
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasRelatoriosStore", [
      "gerarRelatorio",
      "listarUsuarios",
      "listarClientes"
    ]),

    gerar() {
      this.$refs["form"].validate(elFormValidation => {
        const formIsInvalid = !elFormValidation;
        if(formIsInvalid){
          this.$message.warning("Insira os campos obrigatórios.");
          return;
        }
        this.showLoading();

        this.relatorio.pretendente = {
          status: this.relatorio.pretendente.status,
          operacao: this.relatorio.pretendente.operacao,
          bairro: this.relatorio.pretendente.bairro,
          id: this.relatorio.pretendente.id
        }      
        this.gerarRelatorio(this.relatorio)
          .then(resultado => {
            this.hideLoading();
            if (resultado.status == "SUCESSO") {
              window.open(resultado.mensagem, "_blank");
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Não foi possível comunicar-se com o servidor");
          });
        })  
      },
      filtrarClientesSelect(queryString) {
        let payload = {};

        let reg = /^\d+$/;
        reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

        this.loadingClientes = true;
        this.listarClientes(payload)
          .then(() => {
            this.loadingClientes = false;
          })
          .catch(() => {
            this.loadingUsuarios = false;
          });
    },
    filtrarUsuariosSelect(queryString) {
      if(queryString.type && queryString.type === 'focus') { queryString = '' }
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(() => {
        this.loadingUsuarios = false;
      });
    },
    adicionarUsuarioSelecionado() {
      this.usuariosSelecionados.push(this.auxUsuario);
    },
    removerUsuarioSelecionado(usuario) {
      var i;
      for (i = 0; i < this.usuariosSelecionados.length; i++) {
        if (this.usuariosSelecionados[i].id == usuario.id) {
          this.usuariosSelecionados.splice(i, 1);
        }
      }
    },
    formatarSelectCliente(cliente){
      return funcoes.formatarSelectCliente(cliente);
    },
    fechar() {
      this.$emit("close");
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    }
  }
};
</script>

<style scoped>
.form-item {
  width: 100%;
}
.select {
  font-size: 50%;
}
</style>